import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Chybí Supabase konfigurace');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Typy
export interface Customer {
  id: string;
  auth_id: string;
  name: string;
  email: string;
  phone?: string;
  location?: string;
  loyalty_points: number;
  created_at: string;
  updated_at: string;
}

export interface Order {
  id: string;
  customer_id: string;
  customer_name: string;
  customer_phone: string;
  customer_email?: string;
  location: string;
  items: CartItem[];
  total_price: number;
  message?: string;
  status: 'pending' | 'confirmed' | 'in_progress' | 'completed' | 'cancelled';
  points_earned: number;
  created_at: string;
  updated_at: string;
}

export interface CartItem {
  id?: string;
  customer_id?: string;
  service_name: string;
  service_price: number;
  quantity: number;
  created_at?: string;
}
